import axios from 'axios';

export const getSubscriptions = async () => {
    let nowSessionId = window.myAppStrapi && window.myAppStrapi.nowSessionId ? window.myAppStrapi.nowSessionId : undefined;

    const response = await axios.post("https://account.now.com/MyAccount/api/rb/getsubscriptions", {
      secureCookie: nowSessionId,
      callerReferenceNo: new Date().getTime().toString()
    }, {
      headers: {
        'Content-Type': 'text/plain'
      }
    });
    console.log('getSubscriptions', response.data);
    return response.data;
};